export const initialState = {
    mirchiTop20List: null,
  
  };
